import Component from "../abstracts/Component";

const CONTACT_US_IDS = {
  PERSONAL_STYLIST: "personal_stylist",
  PRODUCT_AND_BOX_DAMAGED: "product_and_box_damaged",
  SOME_PRODUCT_ACCESSORIES_ARE_MISSING: "some_product_accessories_are_missing",
  DAMAGED_OR_FAULTY_PRODUCT: "damaged_or_faulty_product",
  WRONG_PRODUCT: "wrong_product",
  WRONG_COLOUR: "wrong_colour",
  PRODUCT_DESCRIPTION_MISMATCHING: "product_description_mismatching",
  ORDER_ARRIVED_AFTER_SCHEDULED_DATE: "order_arrived_after_scheduled_date",
  CHANGED_MY_MIND: "changed_my_mind",
  DONT_LIKE_COLOUR: "dont_like_colour",
  DOESNT_SUIT: "doesnt_suit",
  TOO_SMALL: "too_small",
  TOO_BIG: "too_big",
  OTHER: "other",
  PRIVACY_AND_DATA_PROTECTION: "privacy_and_data_protection",
  ORDERS_AND_DELIVERIES: "orders_and_deliveries",
  PAYMENTS_AND_PROMOTIONS: "payments_and_promotions",
  COLLABORATIONS: "collaborations",
  COMMENTS_AND_SUGGESTIONS: "comments_and_suggestions",
  PRODUCT_INFO_AND_AVAILABILITY: "product_info_and_availability",
  STORES: "stores",
  REFUND_AND_RETURNS: "refund_and_returns",
  TECHNICAL_ASSISTANCE: "technical_assistance",
  RECEIVED_ITEM_WASNT_THE_ORDERED_ONE: "received_item_wasnt_the_ordered_one",
  DOEST_FIT_ME: "doest_fit_me",
  WRONG_SIZE_OR_COLOUR_ORDERED: "wrong_size_or_colour_ordered",
  IMAGINED_ITEM_DIFFERENT: "imagined_item_different",
  RETAIL_STORES: "retail_stores",
  STOCKS_IN_PHYSICAL_STORES: "stocks_in_physical_stores",
  REPAIRS: "repairs",
  PRODUCT_CARE: "product_care",
  ABOUT_MAX_MARA: "about_max_mara",
}

export default class ContactUsComponent extends Component {
  get SELECTORS() {
    return {
      contactUsForm: '#contactUsForm',
      subject: 'select[name="subject"]',
      returns: '[data-contactus-subject="returns"]',
      orders: '[data-contactus-subject="orders"]',
      blocks: '[data-contactus-subject]',
      subjectCode: 'input[name="subjectCode"]',
      ctaDisplayForm: '[data-contactus-show-form]',
      ctaDisplayNewForm: '[data-contactus-show-new-form]',
      submitBtn: '[data-contactus-recaptcha]',
      closeForm: '[data-contactus-close]',
      closeFormCta: '[data-contactus-close]>a',
      datePicker: '#datePick',
      formTab: '[data-contactus-tab]',
      thankYouMsg: '[data-contactus-thanks]',
      thankYouMsgContainer: '#thank-you-message-container'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.ctaDisplayForm = this.$component.querySelector(this.SELECTORS.ctaDisplayForm);
    this.ctaDisplayNewForm = this.$component.querySelector(this.SELECTORS.ctaDisplayNewForm);
    this.contactUsForm = this.$component.querySelector(this.SELECTORS.contactUsForm);
    this.submitBtn = this.$component.querySelector(this.SELECTORS.submitBtn);
  }

  submitForm(data, url) {
    return $.ajax({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  showAdditionalData(index) {
    const ordersBlock = this.$component.querySelector(this.SELECTORS.orders);
    const returnsBlock = this.$component.querySelector(this.SELECTORS.returns);
    switch (index) {
      case 8:
      case '8':
        (ordersBlock ? ordersBlock.classList.add('--hidden') : false);
        (returnsBlock ? returnsBlock.classList.remove('--hidden') : false);
        break;
      case 2:
      case '2':
        (returnsBlock ? returnsBlock.classList.add('--hidden') : false);
        (ordersBlock ? ordersBlock.classList.remove('--hidden') : false);
        break;
      default:
        (ordersBlock ? ordersBlock.classList.add('--hidden') : false);
        (returnsBlock ? returnsBlock.classList.add('--hidden') : false);
    }

    // Get the reference to the select and the hidden input
    const subjectSelect = this.$component.querySelector(this.SELECTORS.subject);
    const subjectCodeInput = this.$component.querySelector(this.SELECTORS.subjectCode);

    // Ensure that an option is selected
    if (subjectSelect && subjectSelect.options[subjectSelect.selectedIndex]) {
      // Get the selected option's data-subject-id attribute
      const selectedOption = subjectSelect.options[subjectSelect.selectedIndex];
      const subjectId = selectedOption.getAttribute('data-subject-id');

      // Check if subjectId exists before assigning it
      if (subjectId) {
        // Set the value of the hidden input to the selected data-subject-id
        console.log('Setting subjectCode input value to: ' + subjectId);
        subjectCodeInput.value = subjectId;
      } else {
        console.warn('Selected option does not have a data-subject-id attribute.');
      }
    }

    // recalc fixed height
    this.resetFormTabMaxHeight();
  }

  afterResponse(success) {
    // if is success
    if (success) {
      // hides current form and cta
      this.contactUsForm.style.display = 'none';
      this.ctaDisplayForm.style.display = 'none';
      this.$component.querySelector(this.SELECTORS.closeForm).style.display = 'none';
      // shows new cta
      this.ctaDisplayNewForm.style.display = 'flex';
      // for new request
      this.bindNewFormCta(this.ctaDisplayNewForm);
    } else {
      // reload calendar
      this.$emit(this.$customEvents.PAGE_LAYOUT_EVENTS.changed);
    }
    // reset button
    this.submitBtn.classList.remove('--loading');

    // recalc fixed height
    this.resetFormTabMaxHeight();
  }

  bindNewFormCta(cta) {
    let ctx = this;
    const link = cta.querySelector('a');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      //hide new cta
      ctx.ctaDisplayNewForm.style.display = 'none';
      //show form
      ctx.contactUsForm.reset();
      const datePick = ctx.contactUsForm.querySelector(ctx.SELECTORS.datePicker);
      if (typeof (datePick) != 'undefined' && datePick != null) {
        datePick.setAttribute('value', '');
        datePick.removeAttribute('disabled');
      }
      ctx.contactUsForm.style.display = 'block';
      if (ctx.isTablet()) {
        ctx.$component.querySelector(ctx.SELECTORS.closeForm).style.display = 'block';
      }
      ctx.ctaDisplayForm.style.display = 'flex';
      //remove response
      if (ctx.$component.querySelector(ctx.SELECTORS.thankYouMsg) != null) {
        ctx.$component.querySelector(ctx.SELECTORS.thankYouMsg).remove();
      }
      ctx.resetFormTabMaxHeight();
    });
  }

  bindSubject() {
    this.$on('change', ({event}) => {

      let blocks = $(this.SELECTORS.contactUsForm).find(this.SELECTORS.blocks);
      let selectedOptions = event.currentTarget.selectedOptions;
      if (selectedOptions[0]) {
        const firstSubjectId = selectedOptions[0].getAttribute('data-subject-id');
        this.showAdditionalData(firstSubjectId);
      }

      blocks.each(function () {
        let $input = $(this).find('input, select');
        if ($(this).hasClass('--hidden')) {
          $input.prop('disabled', true);
        } else {
          $input.prop('disabled', false);
        }
      })

    }, 'body', this.SELECTORS.subject);
  }

  bindCloseForm() {
    const ctx = this;
    this.$component.querySelector(this.SELECTORS.closeFormCta).addEventListener('click', function (e) {
      e.preventDefault();
      ctx.$component.querySelector(ctx.SELECTORS.ctaDisplayForm).click();
    });
  }

  bindSubmit() {
    const ctx = this;
    this.$on('submit', ({event}) => {
      event.preventDefault();
      if (window.RecapchaComponent && !window.RecapchaComponent.getResponseFromWidget('contactUsPage')) {
        // User have not completed the challenge
        return;
      }
      const datePick = this.$component.querySelector(this.SELECTORS.datePicker);
      if (typeof (datePick) != 'undefined' && datePick != null) {
        let date = event.target.querySelector(ctx.SELECTORS.datePicker).getAttribute('value');
        if (date == '') {
          event.target.querySelector(ctx.SELECTORS.datePicker).setAttribute('disabled', '');
        }
      }
      let disabled = $(ctx.SELECTORS.contactUsForm).find('select:disabled').removeAttr('disabled');
      const formData = $(event.target).serialize();
      disabled.attr('disabled', 'disabled');
      const action = event.currentTarget.getAttribute('action');
      // loading button
      ctx.submitBtn.classList.add('--loading');
      ctx.submitBtn.setAttribute('disabled', 'disabled');

      // send promise
      ctx.submitForm(formData, action).then(res => {
        // get form html
        const responseHtml = new DOMParser().parseFromString(res, 'text/html');
        const thankResponse = responseHtml.querySelector(ctx.SELECTORS.thankYouMsgContainer);
        const responseForm = responseHtml.querySelector(ctx.SELECTORS.contactUsForm);
        const success = !!thankResponse;
        // replace html
        event.currentTarget.innerHTML = responseForm.innerHTML;
        ctx.submitBtn = event.currentTarget.querySelector(ctx.SELECTORS.submitBtn);
        if (success) {
          event.currentTarget.parentElement.insertAdjacentHTML('beforeend', thankResponse.innerHTML);
        }
        // afters
        ctx.afterResponse(success);
      });
    }, 'body', this.SELECTORS.contactUsForm);
  }

  resetFormTabMaxHeight() {
    const formTab = this.$component.querySelector(this.SELECTORS.formTab);
    if (formTab) {
      // This is a trick since there is something that set the max-height of the formTab
      formTab.style.maxHeight = 'unset';
    }
  }

  isTablet() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  bindEvents() {
    this.bindSubmit();
    this.bindCloseForm();
  }

  render() {
    this.log('rendering...');
    if ($(this.SELECTORS.subject)) {
      $(this.SELECTORS.subject).trigger('change');
    }
    this.bindEvents();
    if (this.$component.querySelector(this.SELECTORS.returns) || this.$component.querySelector(this.SELECTORS.orders)) this.bindSubject();
  }
}
